import { DataProvider } from './RFILanding/context/DataContext'
import { UiProvider } from './RFILanding/context/UiContext'
import RFILandingInner from './RFILanding/components/RFILandingInner'

export default function RFILanding(props) {
  return (
    <UiProvider>
      <DataProvider>
        <RFILandingInner {...props} />
      </DataProvider>
    </UiProvider>
  )
}
